import { type CategoryModel } from 'cms/cms-types';

interface MapCategory {
    id: number | null;
    name: string;
    description: string;
}

export const resolveCategoriesToMapCategory = (data: (CategoryModel | null)[] | null | undefined): MapCategory | null => {
    if (!data?.length) {
        return null;
    }

    return {
        id: data[0]?.Id || null,
        name: data[0]?.Name || '',
        description: data[0]?.Description || '',
    };
};
